module.exports = __webpack_public_path__ + "static/media/11.fd97e98d.svg";